export default __webpack_public_path__ + "8c12611cee1ba5d46c37d0a8721e86bb.svg";